// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const v1ExternalLinkSchema = z.object({
  provider_type: z.coerce.string(),
  provider_id: z.coerce.string(),
  external_id: z.coerce.string().describe("Provider-side id of the linked item. For provider_type \"timely\" links this mirrors the uri; use linked_work_item_id to key on the item."),
  uri: z.coerce.string().nullish(),
  linked_work_item_id: z.number().int().describe("Id of the native linked work item. Present for provider_type \"timely\" links, alongside the uri.").nullish(),
  data: z.optional(z.object({})),
});
